import { usersRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';
import { HourlyRateJson } from '../types';

export const useCreateUserRate = () =>
  useMutation<
    ApiResponse<{ data: { userId: number } }>,
    unknown,
    HourlyRateJson
  >((userRate) => usersRepo.createUserRate(userRate));
